class Screen {
  down() {
    console.log("The screen is down!");
  }

  up() {
    console.log("The screen is up!");
  }
}

export default Screen;
